import { Navigate } from "react-router-dom";
import { useAuth } from "@/hooks/useAuth";
import { useUserRole } from "@/hooks/useUserRole";
import { useCurrentUserRole } from "@/hooks/useCurrentUserRole";
import { useOrganization } from "@/hooks/useOrganization";

// Org ID para teste do módulo WhatsApp Chat
const JNR_MARKETING_ORG_ID = "0bd78a31-4502-4443-9f0d-fb5d38c2bcde";
// Partner ID para teste do módulo Automações
const FOURUP_LEADS_PARTNER_ID = "5fd9f207-6dc5-4e88-9d59-726d420c5897";

interface InternalRouteProps {
  children: React.ReactNode;
}

const InternalRoute = ({ children }: InternalRouteProps) => {
  const { user, loading: authLoading } = useAuth();
  const { isAdmin, isLoading: roleLoading } = useUserRole();
  const { role, isLoading: currentRoleLoading } = useCurrentUserRole();
  const { currentOrg } = useOrganization();

  if (authLoading || roleLoading || currentRoleLoading) {
    return (
      <div className="flex items-center justify-center min-h-screen">
        <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-primary"></div>
      </div>
    );
  }

  if (!user) {
    return <Navigate to="/auth" replace />;
  }

  // Permitir acesso se:
  // - É superadmin OU
  // - É proprietário OU  
  // - Está na org JNR Marketing (para teste do WhatsApp Chat) OU
  // - Está em uma org do parceiro 4Up Leads (para teste de Automações)
  const isAllowed = isAdmin || 
    role === "proprietario" || 
    currentOrg?.id === JNR_MARKETING_ORG_ID ||
    (currentOrg as any)?.partner_id === FOURUP_LEADS_PARTNER_ID;

  if (!isAllowed) {
    return <Navigate to="/" replace />;
  }

  return <>{children}</>;
};

export default InternalRoute;
